<template>
<!-- eslint-disable -->
  <v-app>
    <Alerts />
    <NavigationDrawer v-if="showAppBar && !loadingData" v-model="showDrawer" />
    <v-app-bar v-if="showAppBar" app style="background-color: #363636" sm="px-1">
      <v-row justify="space-between" align="center" no-gutters>
        <v-col>
          <v-row justify="start" align="center" no-gutters>
            <v-btn @click="showDrawer = true" icon>
              <v-icon>mdi-menu</v-icon>
            </v-btn>
            <v-img
              @click="clickLogo"
              class="shrink mr-2 pointer"
              contain
              :src="require('@/assets/logo.png')"
              transition="scale-transition"
              max-width="200"
            />
          </v-row>
        </v-col>
        <v-btn v-if="loggedIn && $vuetify.breakpoint.smAndUp" text @click="logout">
          <span class="mr-2">{{ 'Cerrar sesión' }}</span>
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-row>
    </v-app-bar>
    <v-main>
      <v-slide-x-reverse-transition mode="out-in">
        <router-view v-if="!showAppBar || (showAppBar && !loadingData) || (inHome && !loadingData)"/>
        <v-container v-else fill-height>
          <v-row justify="center" align="center">
            <v-progress-circular
              size="100"
              indeterminate
              color="viralYellow"
            />
          </v-row>
        </v-container>
      </v-slide-x-reverse-transition>
      <v-footer
        v-if="showAppBar"
        variant="absolute"
        style="background-color: #363636"
        padless
      >
        <v-row justify="center" align="center" class="py-2">
          <v-btn @click="clickCancelacion" text x-small style="text-transform: none">
            <span>Cancelación</span>
          </v-btn>
          <v-btn @click="clickTyc" text x-small style="text-transform: none">
            <span>Términos y condiciones</span>
          </v-btn>
        </v-row>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import Alerts from '@/components/Alerts'
import NavigationDrawer from '@/components/NavigationDrawer'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    Alerts,
    NavigationDrawer
  },
  data() {
    return {
      showDrawer: false
    }
  },
  mounted() {
    this.loadAllData()
  },
  computed: {
    ...mapGetters({
      loggedIn: 'login/loggedIn',
      loadingData: 'viralmobile/getLoading'
    }),
    showAppBar() {
      return this.$route.name != null && !this.$route.name.startsWith('login')
    },
    inHome() {
      return (
        this.$route.name != null &&
        (this.$route.name.startsWith('home') ||
          this.$route.name.startsWith('category') ||
          this.$route.name.startsWith('tyc'))
      )
    }
  },
  methods: {
    ...mapActions({
      logout: 'login/logout',
      loadAllData: 'viralmobile/getData'
    }),
    clickLogo() {
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' })
      }
    },
    clickTyc() {
      this.$router.push({ name: 'tyc' })
    },
    clickCancelacion() {
      this.$router.push({ name: 'cancelacion' })
    }
  }
}
</script>

<style lang="sass">

.v-toolbar__content
  padding: 4px 0 !important
</style>
